import { render, staticRenderFns } from "./VignetteCategory.vue?vue&type=template&id=0d3c4c88&scoped=true"
import script from "./VignetteCategory.vue?vue&type=script&lang=js"
export * from "./VignetteCategory.vue?vue&type=script&lang=js"
import style0 from "./VignetteCategory.vue?vue&type=style&index=0&id=0d3c4c88&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3c4c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3c4c88')) {
      api.createRecord('0d3c4c88', component.options)
    } else {
      api.reload('0d3c4c88', component.options)
    }
    module.hot.accept("./VignetteCategory.vue?vue&type=template&id=0d3c4c88&scoped=true", function () {
      api.rerender('0d3c4c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VignetteCategory.vue"
export default component.exports